/**
 * 侧栏、页面 H1、路由 meta 共用的模块名，避免多处硬编码不一致。
 */
export var FIELD_PARTNERS_MODULE_TITLE = '外勤订单';



// WEBPACK FOOTER //
// ./resources/assets/js/constants/nav-labels.js